/**
 * Blokko brand palette — official color guide.
 * Use these tokens for dashboard UI (tables, badges, backgrounds).
 * Reserve palette.success for status chips and feedback messages only.
 */
export const blokkoColors = {
  logoPurple: '#5933CC',
  logoMagenta: '#BA24BF',
  logoRed: '#FF3333',

  primary: '#513A97',
  primaryDark: '#412e79',
  primaryLight: '#964DE3',
  vibrantLavender: '#964DE3',

  secondary: '#C240B3',
  secondaryDark: '#9A2F8E',
  secondaryLight: '#D66BC4',
  accentRose: '#DF2C75',
  accentViolet: '#614DFF',
  adjustedPink: '#BA4DD1',

  /** Secondary tagline tones — UI accents and soft backgrounds */
  taglineBlue: '#6B82D9',
  taglinePeriwinkle: '#D8DDF5',
  taglineMist: '#EDEAF5',

  /** Purple-tinted table scale (replaces grey/green row fills) */
  tableRow: '#F4F1FA',
  tableRowAlt: '#EAE4F5',
  tableRowHover: '#E2DAF2',
  tableSubtotal: '#E8DFF5',
  tableTotal: '#DDD2F0',

  /** Entity type badges — high-contrast bg/text pairs */
  entity: {
    acquirer: { bg: '#F5E0F2', text: '#7A1F70' },
    iso: { bg: '#D8DDF5', text: '#3D2E6B' },
    merchant: { bg: '#EDE4F8', text: '#412e79' },
  },
};
